import { render, staticRenderFns } from "./assignTaxAccountModal.vue?vue&type=template&id=7f623b01&scoped=true&"
import script from "./assignTaxAccountModal.vue?vue&type=script&lang=js&"
export * from "./assignTaxAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f623b01",
  null
  
)

export default component.exports